import React from "react";
import {
  FaHeartbeat,
  FaUniversity,
  FaTruck,
  FaBook,
  FaBullhorn,
  FaShoppingCart,
  FaMusic,
  FaUsers,
  FaBalanceScale,
  FaBuilding,
} from "react-icons/fa";

function IndustryCard({ icon: Icon, title, description }) {
  return (
    <div className="services-style-four-item">
      <div className="icon" style={{ fontSize: "40px", color: "#000" }}>
        <Icon />
      </div>
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
}

function IndustrySpecific() {
  const industries = [
    {
      title: "Healthcare & Medicine",
      description:
        "Blockchain improves patient data security, interoperability, and transparency in healthcare. From managing patient records to tracking pharmaceutical supply chains, our blockchain solutions ensure data integrity and compliance with health regulations.",
      icon: FaHeartbeat,
    },
    {
      title: "Fintech & Banking",
      description:
        "Streamline transactions, reduce fraud, and improve financial transparency. Xeer Technology’s blockchain solutions for Fintech and Banking enable secure, real-time payments, smart contracts, and decentralized financial services.",
      icon: FaUniversity,
    },
    {
      title: "Supply Chain",
      description:
        "Enhance traceability, efficiency, and trust within your supply chain. Our blockchain solutions track products from origin to end-consumer, reducing fraud, ensuring quality, and building consumer trust.",
      icon: FaTruck,
    },
    {
      title: "EdTech & E-Learning",
      description:
        "Provide secure and verifiable credentialing, transparent tracking, and student data security. We help educational platforms implement blockchain to streamline certifications, attendance, and student data management.",
      icon: FaBook,
    },
    {
      title: "Marketing & Sales",
      description:
        "Blockchain redefines digital advertising by ensuring ad transparency and data privacy. Our solutions empower marketers with tamper-proof tracking, fair compensation, and decentralized digital identity solutions.",
      icon: FaBullhorn,
    },
    {
      title: "E-Commerce & Retail",
      description:
        "Build customer trust through transparent transactions, streamlined logistics, and better inventory management. Blockchain enhances traceability and offers decentralized marketplaces, ensuring secure, reliable operations.",
      icon: FaShoppingCart,
    },
    {
      title: "Arts & Entertainment",
      description:
        "Empower creators with secure digital ownership and fair compensation through NFTs and blockchain-based royalties. Our solutions create secure marketplaces for digital art, music, and other entertainment assets.",
      icon: FaMusic,
    },
    {
      title: "Customer Service & HR",
      description:
        "Optimize recruitment, background checks, and employee data management with blockchain. We offer solutions that simplify onboarding, secure employee data, and improve payroll transparency.",
      icon: FaUsers,
    },
    {
      title: "Legal & Compliance",
      description:
        "Automate contract execution, improve record-keeping, and ensure regulatory compliance. Xeer Technology’s blockchain solutions make legal processes faster, more secure, and more transparent.",
      icon: FaBalanceScale,
    },
    {
      title: "Real Estate",
      description:
        "Reduce paperwork and improve property transaction transparency. Our blockchain solutions support tokenized assets, digital deeds, and efficient property management, making real estate transactions simpler and more secure.",
      icon: FaBuilding,
    },
  ];

  return (
    <div className="team-single-area default-padding">
      <div className="container">
        <div className="team-single-items">
          <div className="row">
            <div className="col-lg-5 left-info">
              <div className="thumb fade-up-anim">
                <img
                  src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                  alt="Thumb"
                />
              </div>
            </div>
            <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
              <div className="container">
                <div className="col-lg-12">
                  <div className="site-heading">
                    <h4 className="sub-title">Our Services</h4>
                    <h2 className="title split-text-right split-text-in-right split-lines">
                      Industry-Specific Blockchain Solutions
                    </h2>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="services-style-four-items">
                  {industries.map((industry, idx) => (
                    <IndustryCard key={idx} {...industry} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndustrySpecific;
